module.exports = __webpack_public_path__ + "img/slika-2.0e4bbd02.png";